import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { TariffTaxPointDto, UpsertTariffTaxPointDto, UpsertTariffTaxPointSubmitDto } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/tariff-tax-points`;

export const getAllTariffTaxPoints = (source: CancelTokenSource): Promise<Array<TariffTaxPointDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data);
};

export const findTariffTaxPointById = (id: number, source: CancelTokenSource): Promise<UpsertTariffTaxPointDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteTariffTaxPoint = (id: number, source: CancelTokenSource): Promise<TariffTaxPointDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addTariffTaxPoint = (upsertTariffTaxPointDto: Partial<UpsertTariffTaxPointSubmitDto>,
                                  source: CancelTokenSource): Promise<TariffTaxPointDto> => {
  return axios
      .post(apiUri, upsertTariffTaxPointDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editTariffTaxPoint = (id: number, upsertTariffTaxPointDto: Partial<UpsertTariffTaxPointSubmitDto>,
                                   source: CancelTokenSource): Promise<TariffTaxPointDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertTariffTaxPointDto, {cancelToken: source.token})
      .then(response => response.data);
};
